import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Field from 'components/Field';
import AsyncSelectLoadMore from 'components/AsyncSelect/AsyncSelectLoadMore';
import WithdrawalDaysBox from 'components/WithdrawalDaysBox';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './FeedRationMedicationRow.module.scss';

const cn = classnames.bind(styles);

// Stable component identity keeps the select mounted (and its loaded options) across form re-renders
const MedicationSelect = ({ input, optionsGetter }) => (
  <AsyncSelectLoadMore
    selected={input.value || null}
    onChange={input.onChange}
    optionsGetter={optionsGetter}
    placeholder={<FormattedMessage id="container.admin.feedRations.selectMedication" />}
    noInputMargin
    autoLoad
  />
);

MedicationSelect.propTypes = {
  input: T.object.isRequired,
  optionsGetter: T.func.isRequired,
};

// One medication row of the feed ration form: typeahead picker + live withdrawal figures + remove
const FeedRationMedicationRow = ({ member, selected, optionsGetter, onRemove, isDuplicate, removeLabel }) => {
  const product = selected?.item;

  return (
    <div className={cn('FeedRationMedicationRow', { 'has-error': isDuplicate })}>
      <div className={cn('row-fields')}>
        <div className={cn('select-column')}>
          <Field name={`${member}.treatment_product`} component={MedicationSelect} optionsGetter={optionsGetter} />
        </div>
        <WithdrawalDaysBox
          className={cn('withdrawal-box')}
          label={<FormattedMessage id="container.admin.feedRations.usaWithdrawalDays" />}
          value={product?.withdrawal_value_us}
          period={product?.withdrawal_period_us}
        />
        <WithdrawalDaysBox
          className={cn('withdrawal-box')}
          label={<FormattedMessage id="container.admin.feedRations.exportWithdrawalDays" />}
          value={product?.withdrawal_value_export}
          period={product?.withdrawal_period_export}
        />
        <button
          type="button"
          className={cn('remove-btn')}
          onClick={onRemove}
          aria-label={removeLabel}
          title={removeLabel}
        >
          <i className="fa fa-times" />
        </button>
      </div>
      {isDuplicate && (
        <span className={cn('error-text')}>
          <FormattedMessage id="container.admin.feedRations.duplicateMedication" />
        </span>
      )}
    </div>
  );
};

FeedRationMedicationRow.propTypes = {
  member: T.string.isRequired,
  selected: T.oneOfType([T.object, T.string]),
  optionsGetter: T.func.isRequired,
  onRemove: T.func.isRequired,
  removeLabel: T.string.isRequired,
  isDuplicate: T.bool,
};

FeedRationMedicationRow.defaultProps = {
  isDuplicate: false,
};

export default FeedRationMedicationRow;
